interface ActionButtonsProps {
  onCancel: () => void;
  onConfirm: () => void;
  onEdit: () => void;
  isConfirming?: boolean;
}

export function ActionButtons({
  onCancel,
  onConfirm,
  onEdit,
  isConfirming = false
}: ActionButtonsProps) {
  return (
    <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-4" data-testid="action-buttons">      <button
        onClick={onEdit}
        className="px-4 py-2 border border-primary/30 rounded-lg text-primary hover:bg-primary/10 transition-colors"
        disabled={isConfirming}
        data-testid="action-buttons-edit-button"
      >
        Edit Booking
      </button>
      <div className="flex flex-1 space-x-4">        <button
          onClick={onCancel}
          className="flex-1 px-4 py-2 border border-border rounded-lg text-foreground hover:bg-secondary transition-colors"
          disabled={isConfirming}
          data-testid="action-buttons-cancel-button"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          disabled={isConfirming}          className={`flex-1 px-4 py-2 rounded-lg text-white transition-colors flex items-center justify-center ${
            isConfirming
              ? 'bg-muted cursor-not-allowed'
              : 'bg-primary hover:bg-primary/90'
          }`}
          data-testid="action-buttons-confirm-button"
        >
          {'Confirm Booking'}
        </button>
      </div>
    </div>
  );
}